import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import admissionFeeDetailService from "../../../services/admissionFeeDetailService";
import applicantFollowupService from "../../../services/applicantFollowupService";
import enquiryFollowupService from "../../../services/enquiryFollowupService";
import enquiryService from "../../../services/enquiryService";
import logger from "../../../services/logger";
import AdmissionFeeConfigTableView from "../../admission/admission-fee-config/admissionFeeConfigTableView";
import Add from "../../common/add";
import BackButton from "../../common/backButton";
import FormDialog from "../../common/formDialog";
import MatChips from "../../common/matChips";
import MatTablePagination from "../../common/matTablePagination";
import PagingAndSorting from "../../common/pagingAndSorting";
import ApplicantFollowupForm from "./applicantFollowupForm";
import ApplicantFollowupsTable from "./applicantFollowupsTable";


class ApplicantFollowups extends PagingAndSorting {
  state = {
    data: [],
    fees: [],
    selectedChip: "ALL",
    sortColumn: { path: "followUpDate", order: "desc" },
    page: 0,
    rowsPerPage: 10,
    totalElements: 0,
    confirmDialogOpen: false,
    dialogOpen:false,
    enquiryId: "",
  };

  prepSortColumn() {
    const { sortColumn } = this.state;
    return sortColumn.path + "," + sortColumn.order;
  }

  async componentDidMount() {
   await this.populateData();
   await this.populateFeeData();
  }

  async populateFeeData() {
    // const { data: fees } = await admissionFeeService.getAll();
    const { data: fees }= await admissionFeeDetailService.getByProgram(this.state.enquiry.programId)
    //console.log("fee details:",fees);
    this.setState({ fees:[fees] });
  }

  async populateData() {
    const applicantId = this.props.match.params.applicantId;
    this.setState({ applicantId });

    const { data: enquiry } = await enquiryService.get(applicantId);
    this.setState({ enquiry });

    const { page, rowsPerPage, selectedChip } = this.state;
    this.getPagedData({
      page,
      size: rowsPerPage,
      followUpType: selectedChip,
      sort: this.prepSortColumn(),
      applicantId,
    });

  }

  handleChipClick = (selectedChip) => {
    //console.log("selectedchip:", selectedChip);
    this.setState({ selectedChip });
    const { page, rowsPerPage } = this.state;
    const sort = this.prepSortColumn();
    this.getPagedData({
      page,
      size: rowsPerPage,
      sort,
      followUpType: selectedChip,
    });
  };

  getPagedData = async (query) => {
    try {
      const applicantId = query.applicantId
        ? query.applicantId
        : this.state.applicantId;

      query.followUpType = query.followUpType
        ? query.followUpType
        : this.state.selectedChip;

      const { data, headers } = await enquiryFollowupService.getAllByQuery(
        applicantId,
        query
      );
      const totalElements = headers["x-total-elements"];
      this.setState({ data, totalElements });
    } catch (ex) {
      logger.error(ex);
    }
  };

  onConfirmOk = async (id) => {
    try {
      const { page, rowsPerPage: size, selectedChip } = this.state;
      await enquiryFollowupService.deleteById(this.state.applicantId, id);
      await this.getPagedData({ page, size, followUpType: selectedChip });
    } catch (ex) {
      logger.error(ex);
    }
  };

  detailsCard(enquiry) {
    return (
      <>
      <Card>
        <CardHeader  title="Enquiry Details" action={<BackButton {...this.props}/> } />
        <br />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
            {<strong>Candidate Name:&nbsp;&nbsp; </strong>}
              {enquiry.userName}
            </Grid>
            <Grid item xs={12} md={3}>
            {<strong>Mobile:&nbsp;&nbsp;</strong>}
            {enquiry.userMobile}
            </Grid>
            <Grid item xs={12} md={3}>
            {<strong>Program: &nbsp;&nbsp;</strong>}
            {enquiry.programName}
          </Grid>
          <Grid item xs={12} md={3}>

          {<strong> Institute: &nbsp;&nbsp;</strong>}{" "}
              {enquiry.instituteName}
            </Grid> 
          <Grid item xs={12} md={3}>
            {<strong>Father's Name:&nbsp;&nbsp;</strong>}
            {enquiry.fatherName}
            </Grid>
            <Grid item xs={12} md={3}>
            {<strong>Father's Mobile:&nbsp;&nbsp;</strong>}
            {enquiry.fatherMobile}
            </Grid>
            <Grid item xs={12} md={3}>
            {<strong>Father's Occupation:&nbsp;&nbsp;</strong>}
            {enquiry.fatherOccupation}
            </Grid>
             <Grid item xs={12} md={3}>
             {<strong>City:&nbsp;&nbsp;</strong>}
            {enquiry.city}
            </Grid> 
            <Grid item xs={12} md={3}>
             {<strong>Area:&nbsp;&nbsp;</strong>}
            {enquiry.area}
            </Grid> 
            <Grid item xs={12} md={3}>
             {<strong>Source:&nbsp;&nbsp;</strong>}
            {enquiry.source}
            </Grid> 

          </Grid>
        </CardContent>
      </Card>
      <br></br>
      </>
    );
  }

  closeDialog = () => {
    this.setState({ dialogOpen: false });
    this.populateData();
  };

  render() {
    const {
      applicantId,
      enquiry,
      sortColumn,
      data,
      fees,
      rowsPerPage,
      page,
      totalElements,
      selectedChip,
      dialogOpen,
      id
    } = this.state;
    const { t } = this.props;
    return (
      <React.Fragment>
        <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
            {/* <br /> */}
            {enquiry && this.detailsCard(enquiry)}
          </Grid>
          <Grid container item xs={12} sm={12} md={8}>
            <br />
            <MatChips
              items={[
                { label: "ALL", value: "ALL" },
                { label: "CALL", value: "CALL" },
                { label: "SMS", value: "SMS" },
                { label: "E-Mail", value: "EMAIL" },
                { label: "Visit", value: "VISIT" },
              ]}
              selected={selectedChip}
              onChipClick={this.handleChipClick}
            />
          </Grid>
          <Grid container item xs={12} sm={12} md={4} direction="row-reverse">
          <br />
            <Add item={{id:"new"}} onAdd={this.handleAdd} title={t("New Followup")} />
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={8} lg={8}>
          <br /><br />
              <ApplicantFollowupsTable
                data={data}
                heading={"Folloup Notes"}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                onDelete={this.handleDelete}
              />
              <MatTablePagination
                rowsPerPageOptions={[5, 10, 25]}
                count={totalElements}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <br /><br />
             {<AdmissionFeeConfigTableView
                data={fees}
                heading={"Followup Notes"}
                sortColumn={sortColumn}
                // onSort={this.handleSort}
                // onDelete={this.handleDelete}
              />}
            </Grid>
          </Grid>
        </Grid>

        {this.renderDeleteConfirmDialog(
          t("Delete Confirmation"),
          t("Are you sure you want to delete?")
        )}

        {dialogOpen && (
          <FormDialog
            id="form-dialog"
            keepMounted
            title={"Followup Details"}
            content={
              <ApplicantFollowupForm
                id={id ? id : "new"}
                onSave={this.closeDialog}
                applicantId={applicantId}
              />
            }
            open={dialogOpen}
            onClose={() => this.setState({ dialogOpen: false })}
          />
        )}

      </React.Fragment>
    );
  }
}

export default withTranslation(["enquiryFollowup"])(ApplicantFollowups);
